import { Invitation, Vet } from '@app/core/models';
import { FeatureToggle } from '@app/core/models/feature-toggles';
import { Market } from '@app/core/models/market';
import { VetPreferences } from '@app/core/models/vet-preferences';
import { UserClaims } from '@okta/okta-auth-js';

export interface VetState {
  vet: Vet | undefined;
  oktaUser: UserClaims | undefined;
  market: Market | undefined;
  isVetValid: boolean;
  currentClinicId: string | undefined;
  invitation: Invitation | undefined;
  preferences: VetPreferences | undefined;
  hasRecoSharingConsent: boolean;
  featureToggles: FeatureToggle[];
}

export const initialVetState: VetState = {
  vet: null,
  oktaUser: undefined,
  market: undefined,
  isVetValid: false,
  currentClinicId: undefined,
  invitation: undefined,
  preferences: undefined,
  hasRecoSharingConsent: false,
  featureToggles: [],
};
